import { getDifferenceBetweenFirstAndLastValues, getDifferenceBetweenSums, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils";

export const twitterFollowersGrowthConfig = [
    {
        plotName: "followers_count",
        metricName: "followers_count",
        sumMetrics: false,
        title: "analytics_growth.followers",
        helpText: "analytics_growth.total_number_of_followers_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "followers_count",
        metricName: "followers_count",
        sumMetrics: false,
        title: "analytics_growth.new_followers",
        helpText: "analytics_growth.users_who_followed_you_recently",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenSums,
    },
]

export const twitterPlatformsGrowthConfig = [


    {
        plotName: "favourites_count",
        metricName: "favourites_count",
        sumMetrics: false,
        title: "analytics_growth.favourites_count",
        helpText: "analytics_growth.total_number_of_favourites_twitter",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "friends_count",
        metricName: "friends_count",
        sumMetrics: false,
        title: "analytics_growth.friends_count",
        helpText: "analytics_growth.total_number_of_friends_count_twitter",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "listed_count",
        metricName: "listed_count",
        sumMetrics: false,
        title: "analytics_growth.listed_count",
        helpText: "analytics_growth.total_number_of_listed_count_twitter",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,

        calculateFunction: getsumOfValues,
    },
    {
        plotName: "statuses_count",
        metricName: "statuses_count",
        sumMetrics: false,
        title: "analytics_growth.statuses_count",
        helpText: "analytics_growth.total_number_of_statuses_twitter",
        cssIcon: "fa-duotone fa-solid fa-images",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    }
]
